import React from 'react'
import Layout from '../../../components/layouts/Layout'
import { useTranslation } from 'react-i18next'
import PrimaryButtonWithIconAdd from '../../../components/ui/PrimaryButtonWithIconAdd';
import { useStoreTypesByAdmin } from '../../../hooks/admin/storeType.admin';
import LoadingErrorState from '../../../components/ui/LoadingErrorState';
import EmptyData from '../../../components/ui/EmptyData';
import StoreTypesTable from '../../../components/admin/storeTypes/StoreTypesListTable';
import { PermissionGate } from '../../../components/admin/PermissionGate';
import { PermissionsKey } from '../../../data/permissions';

function AdminViewAllStoreTypesPage() {
    const {t} = useTranslation();
    const {data:types , isError,isLoading} = useStoreTypesByAdmin();
  return (
    <Layout headline='' title={t('admin_sidebar.store_type')}>
        <div className='flex justify-end'>
            <PermissionGate permissions={[PermissionsKey.CreateTypeOfStore]}>
              <PrimaryButtonWithIconAdd
              buttonLabel="add_new_store_type"
              buttonLinkPath="/admin/add-storeType"
              />
            </PermissionGate>
        </div>
        <LoadingErrorState
        isError={isError}
        isLoading={isLoading}
        />
         {
        types && (
            types.length === 0 ?<EmptyData/> : <StoreTypesTable types={types}/>
        )
        }
    </Layout>
  )
}

export default AdminViewAllStoreTypesPage